import { render, staticRenderFns } from "./EditarItem.vue?vue&type=template&id=4480d79a&scoped=true"
import script from "./EditarItem.vue?vue&type=script&lang=js"
export * from "./EditarItem.vue?vue&type=script&lang=js"
import style0 from "./EditarItem.vue?vue&type=style&index=0&id=4480d79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480d79a",
  null
  
)

export default component.exports